import { render, staticRenderFns } from "./ConfigNavigation.vue?vue&type=template&id=2c8359cd&scoped=true"
import script from "./ConfigNavigation.vue?vue&type=script&lang=js"
export * from "./ConfigNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8359cd",
  null
  
)

export default component.exports